import { createGroup } from './Actions/createGroup';
import { deleteGroup } from './Actions/deleteGroup';
import { getGroups } from './Actions/getGroups';
import { updateGroupMembers } from './Actions/updateGroupMembers';
import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';
import { updateGroupShotgunSpot } from './Actions/updateGroupShotgunSpot';

const actions = {
  createGroup,
  deleteGroup,
  getGroups,
  updateGroupMembers,
  updateGroupShotgunSpot
};

export type IAdminGroupsActions = TActionsWithoutState<typeof actions>;

export default actions;
